import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JgPhysicalInspUnitItemProgress } from '../models/jg/jg-physical-insp-unit-item-progress.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class JgPhysicalInspUnitItemProgressService extends RequestService<JgPhysicalInspUnitItemProgress> {
  static PATH = '/jg/physicalInsp/unit/item/progress';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(
      httpClient,
      JgPhysicalInspUnitItemProgressService.PATH,
      globalService.debugUrl,
    );
  }
}
